<div class="stepper-panel">
    <div class="container m--full-bleed">
        <div class="row m--full-bleed">
            <div class="col-12">
                <div class="form-panel">
                    <!-- Reserve the target for PaymentGateway -->
                    <div id="payment-form"></div>
                </div>
            </div>
        </div>
    </div>
</div>
  